<template>

  <b-modal
    id="edit-operation-construction-modal"
    :ok-title="$t('Validate')"
    :title="$t('Modify') + ' ' + typeConstructionText"
    centered
    no-close-on-backdrop
    ok-only
    ok-variant="primary"
    @ok="handleOk">
    <form ref="operationForm" novalidate>
      <div class="my-2">
        <div>
          <b-form-group
            :label="$t('operationConstruction.Name')"
            class="medium-label mb-4"
            label-for="name-input">
            <b-form-input
              id="name-input"
              v-model="operationConstruction.data.name"
              required
              type="text">
            </b-form-input>
          </b-form-group>
        </div>
        <div class="row mt-2">
          <template v-if="devisValidated || factureValidated">
            <template v-if="devisValidated">
              <div class="col-md-6 mb-2">
                <div class="d-flex prixTTCContainer d-flex justify-content-between">
                  <div>{{ $t('devis.NumeroDevis') }}</div>
                  <div class="prixTTC bold-text">{{ devisValidated.numero }}</div>
                </div>
              </div>


              <div class="col-md-6 mb-2">
                <div class="d-flex prixTTCContainer d-flex justify-content-between">
                  <div>{{ $t(`operationConstruction.prix${isHT ? 'HT': 'TTC'}`) }}</div>
                  <div class="prixTTC bold-text">{{ isHT ? devisValidated.prixHT : devisValidated.prixTTC }}€</div>
                </div>
              </div>

              <div class="col-md-6 mb-2">
                <div class="d-flex prixTTCContainer d-flex justify-content-between">
                  <div>{{ $t('devis.TauxTVA') }}</div>
                  <div class="prixTTC bold-text">{{ devisValidated.tauxTVA }}</div>
                </div>
              </div>

              <div class="col-md-6 mb-4">
                <div class="d-flex prixTTCContainer d-flex justify-content-between">
                  <div>{{ $t('operationHonoraire.ContactName') }}</div>
                  <div class="prixTTC bold-text">{{ devisValidated.artisan.toString }}</div>
                </div>
              </div>

              <div class="col-md-6 mb-2">
              </div>


            </template>
            <template v-for="facture in operationConstruction.data.factures" v-if="factureValidated">
              <div class="col-md-6 mb-2 mt-2">
                <div class="d-flex prixTTCContainer d-flex justify-content-between">
                  <div>{{ $t('facture.NumeroFacture') }}</div>
                  <div class="prixTTC bold-text">{{ facture.nom }}</div>
                </div>
              </div>

              <div class="col-md-6 mb-2 mt-2">
                <div class="d-flex prixTTCContainer d-flex justify-content-between">
                  <div>{{ $t(`operationConstruction.prix${isHT ? 'HT': 'TTC'}`) }}</div>
                  <div class="prixTTC bold-text">{{ facture.prixTTC }}€</div>
                </div>
              </div>

              <div class="col-md-6 mb-2">
                <div class="d-flex prixTTCContainer d-flex justify-content-between">
                  <div>{{ $t('facture.PrixTVA') }}</div>
                  <div class="prixTTC bold-text">{{ facture.prixTVA }}</div>
                </div>
              </div>

              <div class="col-md-6 mb-2">
              </div>
            </template>

            <div class="col-md-6 mt-2">

            </div>

            <div class="col-md-6 mt-2" v-if="devisValidated">

            </div>

            <div class="col-md-6 mb-2 mt-2">
              <div class="d-flex prixTTCContainer d-flex justify-content-between">
                <div>{{ $t(`operationConstruction.total.prix${isHT ? 'HT': 'TTC'}`) }}</div>
                <div class="prixTTC bold-text">{{ prixAffiche }}€</div>
              </div>
            </div>

            <div class="col-md-6" v-if="!devisValidated">
              <AutocompleteField
                v-model="operationConstruction.data.contactName"
                :input-class="'medium-label mb-2'"
                :input-id="'contact-input'"
                :input-label="$t('operationConstruction.Contact.Name')"
                :items="contactNames"
                :required=false
                :search-input="operationConstruction.data.contactName"
                @elementValueChanged="getSelectedValueContact">
              </AutocompleteField>
            </div>

            <div class="col-md-6" v-if="!devisValidated">
            </div>


            <div class="col-md-6 mt-2">
              <b-form-group
                :label="$t('operationConstruction.datedebut')"
                :label-for="'date-input-' + index"
                class="medium-label mb-2">
                <datepicker-input
                  :id="'date-input-' + index"
                  v-model="operationConstruction.data.date"
                  :state="operationConstruction.data.dateState">
                </datepicker-input>
              </b-form-group>
            </div>

            <div class="col-md-6 mt-2">
              <b-form-group
                :label="$t('operationConstruction.datefin')"
                :label-for="'date-input-endDate-' + index"
                class="medium-label mb-2">
                <datepicker-input
                  :id="'date-input-endDate-' + index"
                  v-model="operationConstruction.data.endDate"
                  :state="operationConstruction.data.endDateState">
                </datepicker-input>
              </b-form-group>
            </div>
          </template>
          <template
            v-else-if="!factureValidated && !devisValidated && operationConstruction.data.uniteConstruction.value === 'M2'">

            <div class="col-md-6">
              <b-form-group
                :label="$t('operationConstruction.Surface')"
                :label-for="'Surface-input-' + index"
                class="medium-label mb-2">
                <b-input-group
                  :id="'Surface-input-' + index">
                  <b-form-input
                    v-model="operationConstruction.data.surface"
                    v-disable-scroll
                    min="0"
                    required
                    step="any"
                    type="number"
                    @change="changeValueTTC()"
                    @input="changeValueTTC()">
                  </b-form-input>
                  <b-input-group-append>m²</b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group
                :label="$t('operationConstruction.PrixParM2')"
                :label-for="'PrixParM2-input-' + index"
                class="medium-label mb-2">
                <b-input-group
                  :id="'PrixParM2-input-' + index">
                  <b-form-input
                    v-model="prixParM2Model"
                    v-disable-scroll
                    min="0"
                    required
                    step="any"
                    type="number"
                    @change="changeValueTTC()"
                    @input="changeValueTTC()">
                  </b-form-input>
                  <b-input-group-append>{{ $t(`euros.prix${isHT ? 'HT': 'TTC'}`) }}/m²</b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group
                :label="$t(`operationConstruction.prix${isHT ? 'HT': 'TTC'}`)"
                :label-for="'prixTTC-input-' + index"
                class="medium-label mb-2">
                <b-input-group
                  :id="'prixTTC-input-' + index">
                  <b-form-input
                    v-model="prixAffiche"
                    disabled
                    type="number">
                  </b-form-input>
                  <b-input-group-append>€</b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>


            <div class="col-md-6">
              <b-form-group
                :label="$t('operationConstruction.TauxTVA')"
                :label-for="'tauxTVA-input-' + index"
                class="medium-label mb-2">
                <b-form-select
                  id="'tauxTVA-input-' + index"
                  v-model="operationConstruction.data.tauxTVA"
                  required>
                  <option v-for="option in filteredTauxTVAList" :key="option.value" :value="option.value">
                    {{ $t(option.text) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <AutocompleteField
                v-model="operationConstruction.data.contactName"
                :input-class="'medium-label mb-2'"
                :input-id="'contact-input'"
                :input-label="$t('operationConstruction.Contact.Name')"
                :items="contactNames"
                :search-input="operationConstruction.data.contactName"
                :required=false
                @elementValueChanged="getSelectedValueContact">
              </AutocompleteField>
            </div>
            <div class="col-md-6">
            </div>


            <div class="col-md-6">
              <b-form-group
                :label="$t('operationConstruction.datedebut')"
                :label-for="'date-input-' + index"
                class="medium-label mb-2">
                <datepicker-input
                  :id="'date-input-' + index"
                  v-model="operationConstruction.data.date"
                  :state="operationConstruction.data.dateState">
                </datepicker-input>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group
                :label="$t('operationConstruction.datefin')"
                :label-for="'date-input-endDate' + index"
                class="medium-label mb-2">
                <datepicker-input
                  :id="'date-input-endDate' + index"
                  v-model="operationConstruction.data.endDate"
                  :state="operationConstruction.data.endDateState">
                </datepicker-input>
              </b-form-group>
            </div>

          </template>
          <template v-else-if="operationConstruction.data.uniteConstruction && operationConstruction.data.uniteConstruction.value && operationConstruction.data.uniteConstruction.value.includes('POURCENTAGE')">
            <div class="col-md-6">
              <b-form-group
                :label="$t('operationConstruction.Pourcentage')"
                :label-for="'pourcentage-input-' + index"
                class="medium-label mb-2">
                <b-input-group
                  :id="'pourcentage-input-' + index">
                  <b-form-input
                    v-model="operationConstruction.data.pourcentage"
                    v-disable-scroll
                    min="0"
                    max="100"
                    required
                    step="any"
                    type="number"
                    @change="calculatePourcentageAmount"
                    @input="calculatePourcentageAmount">
                  </b-form-input>
                  <b-input-group-append>%</b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group
                :label="$t(`operationConstruction.prix${isHT ? 'HT': 'TTC'}`)"
                :label-for="'prixTTC-input-' + index"
                class="medium-label mb-2">
                <b-input-group
                  :id="'prixTTC-input-' + index">
                  <b-form-input
                    v-model="prixAffiche"
                    disabled
                    type="number">
                  </b-form-input>
                  <b-input-group-append>€</b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
          </template>
          <template v-else>
            <div class="col-md-6">
              <b-form-group
                :label="$t(`operationConstruction.Prix${isHT ? '.HT': 'TTC'}`)"
                :label-for="'prixTTC-input-' + index"
                class="medium-label mb-2">
                <b-input-group
                  :id="'prixTTC-input-' + index">
                  <b-form-input
                    v-model="prixParM2Model"
                    v-disable-scroll
                    min="0"
                    required
                    step="any"
                    type="number">
                  </b-form-input>
                  <b-input-group-append>{{ $t(`euros.prix${isHT ? 'HT': 'TTC'}`)  }}</b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group
                :label="$t('operationConstruction.TauxTVA')"
                :label-for="'tauxTVA-input-' + index"
                class="medium-label mb-2">
                <b-form-select
                  id="'tauxTVA-input-' + index"
                  v-model="operationConstruction.data.tauxTVA"
                  required>
                  <option v-for="option in filteredTauxTVAList" :key="option.value" :value="option.value">
                    {{ $t(option.text) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <AutocompleteField
                v-model="operationConstruction.data.contactName"
                :input-class="'medium-label mb-2'"
                :input-id="'contact-input'"
                :input-label="$t('operationConstruction.Contact.Name')"
                :items="contactNames"
                :search-input="operationConstruction.data.contactName"
                :required=false
                @elementValueChanged="getSelectedValueContact">
              </AutocompleteField>
            </div>
            <div class="col-md-6">
            </div>

            <div class="col-md-6">
              <b-form-group
                :label="$t('operationConstruction.datedebut')"
                :label-for="'date-input-' + index"
                class="medium-label mb-2">
                <datepicker-input
                  :id="'date-input-' + index"
                  v-model="operationConstruction.data.date"
                  :state="operationConstruction.data.dateState">
                </datepicker-input>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group
                :label="$t('operationConstruction.datefin')"
                :label-for="'date-input-endDate' + index"
                class="medium-label mb-2">
                <datepicker-input
                  :id="'date-input-endDate' + index"
                  v-model="operationConstruction.data.endDate"
                  :state="operationConstruction.data.endDateState">
                </datepicker-input>
              </b-form-group>
            </div>
          </template>

          <div
            v-if="((operationConstruction.data.operation && operationConstruction.data.operation.id !== null ) || ( operationConstruction.selectedLots.length !== 0)) && operationConstruction.data.typeConstruction.value === typeConstruction.value"
            class="col-md-12 mt-2">
            <b-form-group
              :label="$t('operationConstructions.lots.tolink')"
              :label-for="'lots-input'"
              class="medium-label mb-2">

              <div :id="'lots-input'" class="custom-container">
                <template v-for="(operationLot, index) in operationLots">
                  <b-form-checkbox
                    :key="operationLot.id + '-' + operationConstruction.selectedLots.includes(operationLot.id)"
                    :ref="'checkbox' + operationLot.id"
                    :checked="operationConstruction.selectedLots&&operationConstruction.selectedLots.includes(operationLot.id)"
                    :disabled="(operationConstruction.data.hasOwnProperty('factures') && operationConstruction.data.factures.length > 0) || (operationConstruction.data.hasOwnProperty('devis')&&operationConstruction.data.devis.find(devis=>devis.validated === true && devis.id))"
                    @change="handleCheckboxChange(operationLot.id)">
                    <span v-if="operationLot.lotCoPro">{{
                        $t('operation.bilan.Lot') + ' ' + operationLot.lotCoPro
                      }}</span>
                    <span v-else>{{ $t('operation.bilan.Lot') + ' ' + operationLot.lotNumber }}</span>
                  </b-form-checkbox>
                </template>
              </div>
            </b-form-group>
          </div>


        </div>
      </div>
    </form>


  </b-modal>

</template>

<script>
import AutocompleteField from "../../../components/b122/editFields/AutocompleteField";
import DatepickerInput from "../../../components/b122/editFields/DatepickerInput.vue";
import api from "../../../services/api";

export default {
  name: "EditOperationConstructionModal",

  components: {
    AutocompleteField,
    DatepickerInput
  },

  props: {
    operationConstruction: {
      type: Object,
      required: true,
    },
    typeConstruction: {
      type: Object,
      default: null
    },
    tauxTVAList: {
      type: Array,
      default: () => [],
    },
    statusFactureList: {
      type: Array,
      default: () => [],
    },

    contactNames: {
      type: Array,
      default() {
        return []
      }
    },

    operationLots: {
      type: Array,
      default: () => [],
    },
    isHT: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      name: this.operationConstruction.data.name,
      prixAffiche: this.operationConstruction.data.surface
        ? (this.operationConstruction.data.surface * (this.isHT ? this.operationConstruction.data.prixParM2HT : this.operationConstruction.data.prixParM2))
        : (this.isHT ? this.operationConstruction.data.prixHT : this.operationConstruction.data.prixTTC),
      devisValidated: null,
      contactName: null,
      factureValidated: false,
      modalKey: 0,
      selectedDevisIndex: null,
      index: null,
    }
  },

  async mounted() {
    this.name = this.operationConstruction.data.name
    this.index = this.operationConstruction.data.id
    this.manageDevisValidated()
    this.manageFactureValidated()

    if (this.operationConstruction.data.uniteConstruction &&
        this.operationConstruction.data.uniteConstruction.value &&
        this.operationConstruction.data.uniteConstruction.value.includes('POURCENTAGE')) {
      await this.calculatePourcentageAmount()
    } else {
      this.prixAffiche = this.operationConstruction.data.surface
        ? (this.operationConstruction.data.surface * (this.isHT ? this.operationConstruction.data.prixParM2HT : this.operationConstruction.data.prixParM2))
        : (this.isHT ? this.operationConstruction.data.prixHT : this.operationConstruction.data.prixTTC)
    }
  },

  watch: {
    'operationConstruction.data.id': {
      handler: async function (val) {
        this.index = this.operationConstruction.data.id
        this.manageDevisValidated()
        this.manageFactureValidated()

        if (this.operationConstruction.data.uniteConstruction &&
            this.operationConstruction.data.uniteConstruction.value &&
            this.operationConstruction.data.uniteConstruction.value.includes('POURCENTAGE')) {
          await this.calculatePourcentageAmount()
        } else {
          this.prixAffiche = this.operationConstruction.data.surface
            ? (this.operationConstruction.data.surface * (this.isHT ? this.operationConstruction.data.prixParM2HT : this.operationConstruction.data.prixParM2))
            : (this.isHT ? this.operationConstruction.data.prixHT : this.operationConstruction.data.prixTTC)
        }
      },
      deep: true,
    },
    'operationConstruction.data.devis': {
      handler: async function (val) {
        this.index = this.operationConstruction.data.id
        this.manageDevisValidated()
        this.manageFactureValidated()

        if (this.operationConstruction.data.uniteConstruction &&
            this.operationConstruction.data.uniteConstruction.value &&
            this.operationConstruction.data.uniteConstruction.value.includes('POURCENTAGE')) {
          await this.calculatePourcentageAmount()
        } else {
          this.prixAffiche = this.operationConstruction.data.surface
            ? (this.operationConstruction.data.surface * (this.isHT ? this.operationConstruction.data.prixParM2HT : this.operationConstruction.data.prixParM2))
            : (this.isHT ? this.operationConstruction.data.prixHT : this.operationConstruction.data.prixTTC)
        }
      },
      deep: true,
    },
    'operationConstruction.data.pourcentage': {
      handler: async function (val) {
        if (this.operationConstruction.data.uniteConstruction &&
            this.operationConstruction.data.uniteConstruction.value &&
            this.operationConstruction.data.uniteConstruction.value.includes('POURCENTAGE')) {
          await this.calculatePourcentageAmount()
        }
      }
    }
  },

  computed: {

    prixParM2Model: {
      get() {
        return this.isHT ? this.operationConstruction.data.prixParM2HT : this.operationConstruction.data.prixParM2
      },
      set(val) {
        if (this.isHT) {
          this.operationConstruction.data.prixParM2HT = val
        } else {
          this.operationConstruction.data.prixParM2 = val
        }
      }
    },

    filteredTauxTVAList() {
      if (this.tauxTVAList && this.tauxTVAList.length > 0) {
        return this.tauxTVAList.filter(option => option.value !== this.operationConstruction.tauxTVA);
      }
      return []
    },

    typeConstructionText() {
      return this.typeConstruction ? this.$i18n.t(this.typeConstruction.text) : ''
    }
  },

  emits: ['didEditOperationConstruction'],

  methods: {
    getOperationId() {
      if (this.operationConstruction.data.operation && this.operationConstruction.data.operation.hasOwnProperty('id') && this.operationConstruction.data.operation.id) {
        return this.operationConstruction.data.operation.id
      } else if (this.operationConstruction.data.operationLot && this.operationConstruction.data.operationLot.operation && this.operationConstruction.data.operationLot.operation.id) {
        return this.operationConstruction.data.operationLot.operation.id
      }
      return null
    },

    async calculatePourcentageAmount() {
      if (!this.operationConstruction.data.pourcentage || this.operationConstruction.data.pourcentage <= 0) {
        this.prixAffiche = 0
        return
      }

      try {
        const operationId = this.getOperationId()
        if (!operationId) {
          console.error('Impossible de récupérer l\'ID de l\'opération')
          return
        }

        let baseValue = 0
        const pourcentage = this.operationConstruction.data.pourcentage

        if (this.operationConstruction.data.uniteConstruction && this.operationConstruction.data.uniteConstruction.value === 'POURCENTAGE_CA_TTC') {
          const response = await api.get(`/operationConstruction/getCATTC?operationId=${operationId}`)
          baseValue = (response.data.caTTC || 0) / 100
        } else if (this.operationConstruction.data.uniteConstruction && this.operationConstruction.data.uniteConstruction.value === 'POURCENTAGE_COUT_TRAVAUX') {
          const response = await api.get(`/operationConstruction/getCoutTravaux?operationId=${operationId}`)
          baseValue = (response.data.coutTravaux || 0) / 100
        } else {
          const response = await api.get(`/operationConstruction/getPrixRevient?operationId=${operationId}`)
          baseValue = (response.data.prixRevient || 0) / 100
        }

        const prixCalcule = (baseValue * pourcentage) / 100
        this.prixAffiche = Math.round(prixCalcule)
      } catch (error) {
        console.error('Erreur lors du calcul du pourcentage:', error)
        this.prixAffiche = 0
      }
    },

    getSelectedValueContact(data) {
      this.operationConstruction.data.contactName = data
    },

    handleCheckboxChange(lotId) {
      const index = this.operationConstruction.selectedLots.indexOf(lotId);
      if (index === -1) {
        this.operationConstruction.selectedLots.push(lotId);
      } else {
        if (this.operationConstruction.selectedLots.length > 1) {
          this.operationConstruction.selectedLots.splice(index, 1);
        } else {
          this.$refs["checkbox" + lotId][0].checked = true;
          this.$refs["checkbox" + lotId][0].computedLocalChecked = true;
          this.$refs["checkbox" + lotId][0].localChecked = true;
        }
      }
    },


    manageDevisValidated() {
      let devis = this.operationConstruction.data.devis
      this.devisValidated = null
      if (devis) {
        devis.forEach((item, index) => {
          if (item.validated) {
            this.devisValidated = item
            this.operationConstruction.data.tauxTVA = item.tauxTVA
          }
        })
      }
    },

    manageFactureValidated() {
      let factures = this.operationConstruction.data.factures
      this.factureValidated = null
      if (factures && factures.length > 0) {
        this.factureValidated = true
      }
    },


    async changeValueTTC() {
      if (!this.devisValidated) {
        this.prixAffiche = this.operationConstruction.data.surface
          ? (this.operationConstruction.data.surface * (this.isHT ? this.operationConstruction.data.prixParM2HT : this.operationConstruction.data.prixParM2))
          : (this.isHT ? this.operationConstruction.data.prixHT : this.operationConstruction.data.prixTTC)
      }
    },

    handleOk($event) {
      const form = this.$refs.operationForm;
      if (!form.reportValidity() || !this.operationConstruction.data.date || !this.operationConstruction.data.endDate) {
        $event.preventDefault();
        return
      }
      this.handleSubmit();
    },

    handleSubmit() {
      if (this.operationConstruction && this.operationConstruction.data) {
        this.$emit('didEditOperationConstruction', this.operationConstruction)
      }

      this.resetModal()
      this.hideModal()
    },

    resetModal() {
    },

    hideModal() {
      this.$bvModal.hide('edit-operation-construction-modal')
    },

  }

}

</script>

<style scoped>
.prixTTCContainer {
  padding: 8px 12px;
  background-color: #F4F4F4;
  color: #07153C;
  border: solid 1px #CCCCCC;
}

.prixTTC {
  color: var(--main-color);
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: 0 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.grey-text {
  color: #AAAAAA;
}

.custom-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.custom-container > * {
  margin-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/EditOperationConstructionModal.vue